import axios from "axios";
import { FlowBaseFieldUpdateRequest } from "../models/requests/FlowBaseFieldUpdateRequest";
import { AutonomousFormAttachmentField } from "../models/responses/AutonomousFormAttachmentField";
import { FlowAttachmentFieldCreateRequest } from "../models/requests/FlowAttachmentFieldCreateRequest";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlows";
function getUrl(flowId: number, fieldId?: number) {
  const urlEnd = fieldId?.toString() ?? "";
  return `/${flowId}/AttachmentFields/${urlEnd}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getField(fieldId: number, flowId: number) {
  const url = getUrl(flowId, fieldId);
  return await instance.get<AutonomousFormAttachmentField>(url);
}

async function getFields(flowId: number) {
  const url = getUrl(flowId);
  return await instance.get<AutonomousFormAttachmentField[]>(url);
}

async function setField(
  fieldId: number,
  flowId: number,
  field: FlowBaseFieldUpdateRequest
) {
  return await instance.put<AutonomousFormAttachmentField>(
    getUrl(flowId, fieldId),
    field
  );
}

async function deleteField(fieldId: number, flowId: number) {
  return await instance.delete(getUrl(flowId, fieldId));
}

async function createField(
  flowId: number,
  field: FlowAttachmentFieldCreateRequest
) {
  return await instance.post<AutonomousFormAttachmentField>(
    getUrl(flowId),
    field
  );
}

export const AutonomousFormAttachmentFieldService = {
  getField,
  setField,
  deleteField,
  createField,
  getFields
};
